import { IAppLanguage } from '../models/global-header.model';

export const APP_LANGUAGES: IAppLanguage[] = [
    {
        langName: 'English',
        langCode: 'en',
        translation: 'English',
    },
    {
        langName: 'Hindi',
        langCode: 'hi',
        translation: 'हिंदी',
    },
    {
        langName: 'Tamil',
        langCode: 'ta',
        translation: 'தமிழ்',
    },
    {
        langName: 'Urdu',
        langCode: 'ur',
        translation: 'اردو',
    },
    {
        langName: 'Kannada',
        langCode: 'kn',
        translation: 'ಕನ್ನಡ',
    },
    {
        langName: 'Marathi',
        langCode: 'mr',
        translation: 'मराठी',
    },
    {
        langName: 'Punjabi',
        langCode: 'pa',
        translation: 'ਪੰਜਾਬੀ',
    },
    {
        langName: 'Bengali',
        langCode: 'bn',
        translation: 'বাংলা',
    },
    {
        langName: 'Telugu',
        langCode: 'te',
        translation: 'తెలుగు',
    },
    {
        langName: 'Sindhi',
        langCode: 'sd',
        translation: 'سنڌي',
    },
    {
        langName: 'Gujrati',
        langCode: 'gu',
        translation: 'ગુજરાતી',
    },
    {
        langName: 'Sansakrit',
        langCode: 'sa',
        translation: 'संस्कृतम्',
    },
    {
        langName: 'Odia',
        langCode: 'or',
        translation: 'ଓଡିଆ',
    },
    {
        langName: 'Assamese',
        langCode: 'as',
        translation: 'অসমীয়া',
    },
    {
        langName: 'Bhojpuri',
        langCode: 'bho',
        translation: 'भोजपुरी',
    },
    {
        langName: 'Awadhi',
        langCode: 'awa',
        translation: 'अवधी',
    },
    {
        langName: 'Malayalam',
        langCode: 'ml',
        translation: 'മലയാളം',
    },
    {
        langName: 'Nepali',
        langCode: 'ne',
        translation: 'Nepali',
    },
];

export const DEFAULT_LANGUAGE = APP_LANGUAGES[0];
export const DEFAULT_FONT_SIZE = 12;
